export default "__VITE_ASSET__2af967d5__"